import { IComponentOptions, IController, INgModelController } from 'angular';
import { Mail } from '../../shared/mail';
import { $Event, Helpers } from '../../../../helpers';
import './mail-item.component.scss';
import { MailboxService } from '../../services';
// import '../../../../../styles/elements/inputs.scss';

class MailItemCtrl implements IController {

  static $inject = [
    'MailboxService'
  ];

  mail: Mail;
  isSelected: boolean;
  onDelete: ( $event: $Event<Mail> ) => void;
  onImportant: ( $event: $Event<Mail> ) => void;
  onSelect: ( obj: any ) => void;
  onOpen: ( obj: any ) => void;
  isOpened: boolean;
  helpers = Helpers;
  checked: boolean;
  id: string;
  isMobile: boolean;

  constructor(private mailService: MailboxService) {
  }

  $onChanges() {
    this.onChecked();
  }

  $onInit() {
  }

  get logoClasses(): object {
    return {
      red: this.mail.type === 'admin',
      blue: this.mail.type === 'business' || this.mail.type === 'job',
      green: this.mail.type === 'finance'
    };
  }

  get importantBtnClasses(): object {
    return {
      important: this.mail.important
    };
  }

  get logoCharType(): string {
    return this.mail.type.charAt(0);
  }

  get mailClasses(): object {
    return {
      'opened': this.mail.is_open,
      'is-read': this.mail.is_read
    };
  }

  onDeleteClick( event: Event ) {
    event.stopPropagation();
    this.onDelete(new $Event(this.mail));
  }

  onImportantClick( event: Event ) {
    event.stopPropagation();
    this.onImportant(new $Event(this.mail));
  }

  onChecked() {
    this.onSelect({
      $event: {
        checked: this.isSelected,
        id: this.mail._id
      }
    });
  }

  onSelectClick() {
    this.onSelect(new $Event(this.mail));
  }

  onExpandToggle() {
    console.log('expand');
  }

  openMail() {
    if ( !this.mail.is_read ) {
      this.mail.is_read = true;
      this.mailService.$readEmail.next(this.mail.type);
    }
    this.onOpen({ id: this.mail._id});
  }
}

export const MailItemComponent: IComponentOptions = {
  controller: MailItemCtrl,
  template: require('./mail-item.component.html'),
  bindings: {
    mail: '<',
    isSelected: '<',
    isOpened: '<',
    onDelete: '&',
    onOpen: '&',
    onImportant: '&',
    onSelect: '&',
    isMobile: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states/mailbox/components/mail-item/mail-item.component.ts